import { render, staticRenderFns } from "./AbstractPage.vue?vue&type=template&id=5ba99669"
import script from "./AbstractPage.vue?vue&type=script&lang=ts"
export * from "./AbstractPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports